import React, { Component, Suspense, useEffect, useState } from "react";
// import calender from "../images/icon-calender.png";
// import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dataUpdate, saveItCareerForm } from '../service.js';
import Close from "../images/close-mark.png";
import Active from "../images/tick.png"
import Deactivate from "../images/deactvate.png"
import Edit from "../images/edit.png"
import { cityNameGlobal } from "../components/GlobalCity.js";
import $ from "jquery"
const Header = React.lazy(() => import("../layout/header"))
const Footer = React.lazy(() => import("../layout/admin_footer"))
// var cityName = window.location.host.split('.')[0]
// var cityName ="bangalore"
const city = window?.location?.pathname?.split?.('/')?.pop?.();

const cityName = cityNameGlobal ? cityNameGlobal : city

function CenterList() {
    if (localStorage.getItem("isLogedIn") === "null" || localStorage.getItem("isLogedIn") === null) {
        window.location.href = '/cms-login'
      }
    const [contactReport, setContactReport] = useState([]);
    const [stateDetails, setStateDetails] = useState([]);
    const [centreDetails, setCentreDetails] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [centreName, setcentreName] = useState("");
    const [stateMatching, setStateMatching] = useState("");
    const [forStateMatching, setforStateMatching] = useState("");
    const [stateMatchingName, setStateMatchingName] = useState("");
    const [centerMatching, setCenterMatching] = useState("");
    const [centerMatchingName, setCenterMatchingName] = useState("");
    const [campaignCenterListId, setCampaignCenterListId] = useState("");
    const [show, setShow] = useState(false);
    useEffect(() => {
        centerListing()
        stateAndCenter()
    }, []);

    const centerListing = () => {
        const postData = {
            "functionName": "campaignCentreListListing",
            "centreName": cityName,
            "status": "",
            "offset": "",
            "max": ""
        };
        dataUpdate(postData).then((data) => {
            console.log('getCourseList-- ', data)
            if (data.data.success === '1') {
                setContactReport(data.data.result.centres);
                setsearchValue(data.data.result.centres)
                setcentreName(data.data.result.centres.centreName)
                // setId(data.data.result.centres.id)
                console.log("data............", data);
            }
            else {
            }
        });
    }
    const PopupShow = () => {
        $("#popupModal").show();
        setCampaignCenterListId("")
    }
    const PopupClose = () => {
        $("#popupModal").hide();
        $("#txtStateName").val("0");
        $("#txtCenterName").val("0");
        $("#txtMobileNumber").val("");
        $("#txtCallNowNumber").val("");
        $("#txtCallMeBackNumber").val("");
    }
    const EditPopupShow = (item) => {
        console.log(item, "eeeeeeeeeeeeeeeee")
        $("#edit_popupModal").show()
        setCampaignCenterListId(item.id)
        setStateMatching(item.stateId)
        setStateMatchingName(item.stateName)
        setCenterMatchingName(item.centreName)
        setforStateMatching(item.centreId)
        document.getElementById('txtMobileNumberEdit').value = item.mobileNumber
        document.getElementById('txtCallNowNumberEdit').value = item.callNowNumber
        document.getElementById('txtCallMeBackNumberEdit').value = item.callMeBackNo
    }
    const EditPopupClose = () => {
        $("#edit_popupModal").hide()
    }
    const startWithIgnoringCase = (text, other) => {
        return (text.toLowerCase().includes(other.toLowerCase()))
    }
    const centerList = (e) => {
        setShow(true)
        let filterCenter;
        if (e.target.value === "") {
            filterCenter = searchValue;
        } else {
            filterCenter = searchValue.filter((x) => {
                return startWithIgnoringCase(x.centreName, e.target.value);
            });
        }
        setContactReport(filterCenter)
    }
    const statusTypeChange = (id, status) => {
        var x = false;
        if (status !== true) {
            x = window.confirm('Do you want to Disable this?');
        } else {
            x = window.confirm('Do you want to Enable this?');
        }
        if (x === true) {
            const postData = {
                functionName: "campaignCentreListDelete",
                campaignCenterListId: id,
                isActive: status == false ? false : true,
            };
            dataUpdate(postData).then((data) => {
                console.log('changeeeeeee------------ ', data)
                if (data.data.success === '1') {
                    if (show === false) {
                        centerListing();
                        // window.location.reload()
                    }
                    else {
                        centerListing();
                        // window.location.reload()
                    }
                }
            });
        }
    };
    const saveCenterDetails = () => {

        let flag = true;
        if (!stateMatchingName) {
            alert('Choose State');
            return false;
        }
        else if (!centerMatchingName) {
            alert('Choose Center');
            return false;
        }
        else if (!campaignCenterListId) {
            if (document.getElementById('txtMobileNumber').value === '') {
                alert('Enter Mobile');
                return false;
            }
        }
        else if (campaignCenterListId) {
            if (document.getElementById('txtMobileNumberEdit').value === '') {
                alert('Enter Mobile');
                return false;
            }
        }
        const postData = {
            "functionName": "saveCampaignCentreList",
            "sub_domain":cityName,
            "stateId": stateMatching,
            "stateName": stateMatchingName,
            "centreName": centerMatchingName,
            "centreId": forStateMatching,
            "mobileNo": campaignCenterListId === "" ? document.getElementById('txtMobileNumber').value : document.getElementById('txtMobileNumberEdit').value,
            "callNowNo": campaignCenterListId === "" ? document.getElementById('txtCallNowNumber').value : document.getElementById('txtCallNowNumberEdit').value,
            "callMeBackNo": campaignCenterListId === "" ? document.getElementById('txtCallMeBackNumber').value : document.getElementById('txtCallMeBackNumberEdit').value,
            "campaignCenterListId": campaignCenterListId === "" ? "" : campaignCenterListId,
        };
        console.log('saveeeeeeeeeeee-------1----- ', postData)
        dataUpdate(postData).then((data) => {
            console.log('saveeeeeeeeeeee-------2----- ', data)
            if (data.data.success === '1') {
                if (campaignCenterListId == "") {
                    alert("Center saved Successfully");
                    window.location.href = '/centerList';
                }
                else {
                    alert("Center updated Successfully");
                    window.location.href = "/centerList";
                }
            } else {
                alert(data.data.errorMessage);
                window.location.href = '/centerList';
            }
        });
    };

    const stateAndCenter = () => {
        const postData = {
            "functionName": "getStateAndCentreDetails"
        };
        saveItCareerForm(postData).then((data) => {
            console.log('stateandcenterrrrrrrrrrrrrrr--', data)
            if (data.data.success === '1') {
                console.log('stateandcenterrrrrrrrrrr rrrr-22222222-', data.data.result.centreDetails)
                setStateDetails(data.data.result.stateDetails);
                setCentreDetails(data.data.result.centreDetails);
            }
        })
    }
    const onChangeCenter = (e) => {
        console.log(e.split('*'))
        setStateMatching(e.split('*')[0])
        setStateMatchingName(e.split('*')[1])
    }
    const onChangeState = (e) => {
        setforStateMatching(e.split('*')[0])
        setCenterMatching(e.split('*')[0])
        setCenterMatchingName(e.split('*')[1])
    }
    return (
        <div>
            <div className='admin_dashboard_wrapr reports_wrapr'>
                <Suspense fallback={<div></div>}>
                    <Header />
                    <div className="container">
                        <div className="breadcrumbs breadcrumbs_dashboard">
                            <ul>
                                <li>
                                    <Link to="/dashboard">Dashboard</Link>
                                </li>
                                <div class="breadcrumbarrow-right" />
                                <li>Manage Campaign Form - Centre Listing</li>
                            </ul>
                        </div>
                        <div className="mt-3">
                            <h2 className="text-center w-100 mb-4">Campaign Centers List</h2>
                            <div className="row am_block text-center pb-3">
                                <div className="col-lg-6 col-md-3 input-div">
                                    <input
                                        type="text"
                                        placeholder="Search By Center Name"
                                        className="form-control"
                                        name="searchValue"
                                        centerList
                                        onKeyUp={centerList}
                                        id="searchValue"
                                    />
                                </div>
                                {/* <div className="col-lg-2 col-md-3 input-div">
                                    <img src={calender} className="formImage" alt="calender" />
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="yyyy/MM/dd"
                                        id="datewiseDeliverOrderFromDate"
                                        name="datewiseDeliverOrderFromDate"
                                        placeholderText="Start Date"
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 input-div">
                                    <img src={calender} className="formImage" alt="calender" />
                                    <DatePicker
                                        dateFormat="yyyy/MM/dd"
                                        className="form-control"
                                        id="datewiseDeliverOrderToDate"
                                        name="datewiseDeliverOrderToDate"
                                        placeholderText="End Date"
                                    />
                                </div> */}
                                <div className="col-lg-6 col-md-12 input-div" style={{ textAlign: "right" }}>
                                    <button
                                        type="button"
                                        className="saveButton"
                                        onClick={PopupShow}
                                    >
                                        Add Center List
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="ml-auto topPagination">
                                    {/* <Pagination
                 activePage={this.state.activePage}
                 itemsCountPerPage={10}
                 totalItemsCount={this.state.totalCount}
                 pageRangeDisplayed={10}
                 onChange={this.handlePageChange}
               /> */}
                                </div>
                            </div>
                            <div className="table-responsive table_report">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>SR Number</th>
                                            <th>State Name</th>
                                            <th>Mobile no.</th>
                                            <th>Center Id</th>
                                            <th>Center Name</th>
                                            <th>Call Now Number</th>
                                            <th>Call Me Back Number</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contactReport.map((item, i) => (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td>{item.stateName}</td>
                                                <td>{item.mobileNumber}</td>
                                                <td>{item.centreId}</td>
                                                <td>{item.centreName}</td>
                                                <td>{item.callNowNumber}</td>
                                                <td>{item.callMeBackNo}</td>
                                                <td className="text-center cursor_pointer" >

                                                    {item.is_active == false ? (
                                                        <img src={Deactivate} alt="Deactivate"
                                                            title="Click to Activate"
                                                            width={22} height={22}
                                                            onClick={() => {
                                                                statusTypeChange(item.id, true);
                                                            }}
                                                            
                                                        />
                                                    ) : (
                                                        <img src={Active} alt="Active"
                                                            title="Click to Deactivate"
                                                            width={20} height={20}
                                                            onClick={() => {
                                                                statusTypeChange(item.id, false);
                                                            }}
                                                        />
                                                    )}
                                                </td>
                                                <td className="cursor_pointer"><img src={Edit} alt="Edit" title="Click to EDIT" width={17} height={17}

                                                    onClick={() => {
                                                        EditPopupShow(item);
                                                    }}
                                                /></td>
                                            </tr>
                                        ))}
                                        {/* <div>No Data Found</div> */}
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <div className="ml-auto bottomPagination">
                                    {/* <Pagination
                 activePage={this.state.activePage}
                 itemsCountPerPage={10}
                 totalItemsCount={this.state.totalCount}
                 pageRangeDisplayed={10}
                 onChange={this.handlePageChange}
               /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <div class="adminpopup_wrapr" id="popupModal">
                        <>
                            <div class="reveal-modal">
                                <div
                                    className="popup_close"
                                    onClick={PopupClose}
                                >
                                    <img
                                        src={Close}
                                        alt="Close"
                                        width={25}
                                        className="close_btn"
                                    />
                                </div>
                                <h3 className="centerlist_head">ADD CENTER LIST</h3>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">State Name<span className="start_red">*</span></label>
                                    <div class="col-sm-8">
                                        <select className="form-control"
                                            type="text"
                                            onChange={(e) => onChangeCenter(e.target.value)}
                                            name="txtStateName"
                                            id="txtStateName"
                                            placeholder="Add State Name">
                                            <option value="0">State Name</option>
                                            {stateDetails.map((data, i) => {
                                                return (
                                                    <option value={data.stateId + "*" + data.stateName}>{data.stateName}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Center Name<span className="start_red">*</span></label>
                                    <div class="col-sm-8">
                                        <select className="form-control"
                                            type="text"
                                            // onChange={(e) => this.textImageList(e.target.value)} 
                                            name="txtCenterName"
                                            onChange={(e) => onChangeState(e.target.value)}
                                            id="txtCenterName"
                                            placeholder="Add Center Name">
                                            <option value="0">Center Name</option>
                                            {/* {item.labOrderData.filter((objec) => objec.labReqId).map((obj, k) => ( */}
                                            {centreDetails.filter((centreDetails => centreDetails.stateId === stateMatching)).map((data, i) => {
                                                return (
                                                    <option value={data.centreId + "*" + data.centreName}>{data.centreName}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Mobile Number<span className="start_red">*</span></label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtMobileNumber"
                                            class="form-control"
                                            placeholder="Add Mobile Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Call Now Number</label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtCallNowNumber"
                                            class="form-control"
                                            placeholder="Add Call Now Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Call Me Back Number</label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtCallMeBackNumber"
                                            class="form-control"
                                            placeholder="Call Me Back Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="text-center mt-3">
                                    <button
                                        type="button"
                                        className="saveButton"
                                        onClick={saveCenterDetails}>
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="saveButton cancelbtn"
                                        onClick={PopupClose}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                    <div class="adminpopup_wrapr" id="edit_popupModal">
                        <>
                            <div class="reveal-modal">
                                <div
                                    className="popup_close"
                                    onClick={EditPopupClose}
                                >
                                    <img
                                        src={Close}
                                        alt="Close"
                                        width={25}
                                        className="close_btn"
                                    />
                                </div>
                                <h3 className="centerlist_head">EDIT CENTER - {centerMatchingName}</h3>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Call Now Number</label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtCallNowNumberEdit"
                                            class="form-control"
                                            placeholder="Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Call Me Back Number</label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtCallMeBackNumberEdit"
                                            class="form-control"
                                            placeholder="Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Mobile Number <span className="start_red">*</span></label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            id="txtMobileNumberEdit"
                                            class="form-control"
                                            placeholder="Mobile Number"
                                            onKeyPress={(event) => {
                                                if (!/[0-9,]/.test(event.key)) {
                                                    event.preventDefault();
                                                    alert("Only Number Accepted");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="text-center mt-3">
                                    <button
                                        type="button"
                                        className="saveButton"
                                        onClick={saveCenterDetails}
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="saveButton cancelbtn"
                                        onClick={EditPopupClose}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                </Suspense>
            </div></div>
    )
}
export default CenterList;